export default {
  load: cb => cb(require('./InfoBox'))
};
